export default {
    isDev: false,
    dev: 'http://localhost:44338/v2/api/',
    pro: 'https://api.carruseldeactores.com/v2/api/',
    getUrl() {
        return this.isDev ? this.dev : this.pro;
    }
}